import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AssetTimeline, AssetTimelineParams } from '@zero/shared/util-models';
import { AssetTimelineInfo } from '../entities/asset-timeline-info.entity';
import { DerivativeData, DerivativeDataVisibility } from '../entities/derivative-data.entity';

export const instrumentDetailActions = createActionGroup({
  source: 'InstrumentDetail',
  events: {
    'Load Asset Timeline': props<{ force: boolean; params: AssetTimelineParams }>(),
    'Load Asset Timeline Info': props<{ isin: string }>(),
    'Reset Asset Timeline': emptyProps(),
    'Load Derivative Data': props<{ isin: string }>(),
    'Reset Derivative Data': emptyProps(),
    'Check Derivative Data Visibility': emptyProps(),
    'Set Derivative Data Visibility': props<{ visibility: DerivativeDataVisibility }>(),
    'Toggle Derivative Base Data Visibility': emptyProps(),
    'Toggle Derivative Key Data Visibility': emptyProps(),
    'Toggle Derivative Payout Profile Visibility': emptyProps(),
    'Cache Derivative Data Visibility': props<{ visibility: DerivativeDataVisibility }>(),
  },
});

export const instrumentDetailApiActions = createActionGroup({
  source: 'InstrumentDetail API',
  events: {
    'Load Asset Timeline From Api': props<{ params: AssetTimelineParams }>(),
    'Load Asset Timeline Success': props<{ isin: string; assetTimeline: AssetTimeline }>(),
    'Load Asset Timeline Failure': props<{ error: HttpErrorResponse }>(),
    'Load Asset Timeline Info Success': props<{ assetTimelineInfo: AssetTimelineInfo }>(),
    'Load Asset Timeline Info Failure': props<{ error: HttpErrorResponse }>(),
    'Load Derivative Data Success': props<{ derivative: DerivativeData }>(),
    'Load Derivative Data Failure': props<{ error: HttpErrorResponse }>(),
  },
});
